export const Code_Medications = 'medications';
export const FHIR_List_CodeOptions = [
    Code_Medications,
];
export const FHIR_List_CodeOptions_ToLabelsMap = {
    [Code_Medications]: 'Medications',
};
//# sourceMappingURL=consts.js.map